const photosTemplate = require('20220101/templates/widgets/stacking-grid/photos.hbs');
const indexTemplate = require('20220101/templates/widgets/stacking-grid/index.hbs');
import widgetMixin from "./widget-mixin.js";
import { throttle } from 'throttle-debounce';

const sizeMap = {
  large: "300",
  medium: "240",
  small: "150"
}

const DEFAULTS = {
  photoSize: "large",
  numPhotos: 12
}

class StackingGridWidget extends widgetMixin(HTMLElement) {
  constructor() {
    super();

    this.DEFAULTS = DEFAULTS;
    this.photos = [];
    this.fetchMorePhotos = false;
  }

  beforeRerender() {
    if (this.photos.length > this.numPhotos) {
      this.photos = this.photos.slice(0, this.numPhotos);
    }

    if (this.photos.length < this.numPhotos) {
      this.photos = [];
      this.fetchPhotos();
    }
  }

  render() {
    this.per = this.numPhotos;
    this.page = 1;

    if (this.initialized) { this.beforeRerender() }

    console.log("rendering, photoSize is", this.photoSize);
    console.log("feed is ", this.feed);

    this.renderIndex();
    this.appendPhotos(this.photos);
  }

  renderIndex() {
    const renderedIndex = indexTemplate({numPhotos: this.numPhotos, photoSize: sizeMap[this.photoSize]||sizeMap.large, preferences: this.preferences, uuid: this.uuid});
    this.shadow.innerHTML = renderedIndex;
    this.appendCustomCSS();
  }

  appendPhotos(photos) {
    const renderedPhotos = photosTemplate({photos: photos, preferences: this.preferences});
    this.shadow.querySelector('.l2h-photos').insertAdjacentHTML('beforeend', renderedPhotos);
    this.renderHeader();
  }

  static get observedAttributes() {
    return ['num-photos'].concat(super.observedAttributes)
  }
}

customElements.define("l2h-stacking-grid-widget", StackingGridWidget);
